
import { error } from 'jquery';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService } from 'src/app/services/logger.service';
import { LoaderService } from 'src/app/loader.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-pages-login-with-token-component',
  templateUrl: './pages-login-with-token-component.component.html',
  styleUrls: ['./pages-login-with-token-component.component.css']
})
export class PagesLoginWithTokenComponent implements OnInit {
  token: any
  url:any;
  adminName:any;
  constructor(private logger: LoggerService, private http: HttpClient, public _LoaderService: LoaderService, private router: ActivatedRoute, private route: Router) { }

  async ngOnInit(): Promise<void> {


    this.router.queryParams.subscribe(params => {
      this.token = params['token'];
      this.url = params['url'];
      this.adminName = params['adminName'];
    });
    await this.getAdminDetails()
  }
  async getAdminDetails() {
    // this._LoaderService.ShowLoader()

    var endPoint = "login-admin-details";
    var payload = {
      token: this.token,
      // url:"https://members.groupbenefitz.aitestpro.com/"

       adminName:this.adminName
    }
    try {

      this.http.post(environment.commonLoginApiUrl + endPoint, payload).subscribe(async (response: any) => {
      
      
      
            if (response?.status == 200 || response?.statusCode == 200) {
      
              sessionStorage.setItem("signinResults", JSON.stringify(response.data));
      
              sessionStorage.setItem("accessToken", response["token"]);
              sessionStorage.setItem("loginname", response.data.email);
              sessionStorage.setItem("adminName", response.data.userName);
              sessionStorage.setItem("groupAdminId", response.data.groupAdminId);
              sessionStorage.setItem("brokerId", response.data.brokerId);
              sessionStorage.setItem("role", response.data.role);
              sessionStorage.setItem("language", "English");
              if (response && response.settings && response.settings.length > 0) {
                sessionStorage.setItem("fileSize", response.settings[0].settingsValue);
              }
              // await this.getLangTokens()
      
      
              var corporateId = sessionStorage.getItem('corporateId');
              var accessToken = sessionStorage.getItem('accessToken');
              var getClients = '/api/ap/admin/corporate/details/false';
              var getAdvisors = '/api/ap/brokers/details';
              var getMembers = '/api/ap/admin/customers/list';
      
              let prefetchurls = []
      
              let Data = [{
                url: environment.apiUrl + getClients,
                // fetch options
                options: {
      
                  mode: 'cors',
                  headers: {
      
                    Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                  }
                }
              },
              {
                url: environment.apiUrl + getAdvisors,
                // fetch options
                options: {
      
                  mode: 'cors',
                  headers: {
      
                    Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                  }
                }
              },
              {
                url: environment.apiUrl + getMembers,
                // fetch options
                options: {
      
                  mode: 'cors',
                  headers: {
      
                    Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                  }
                }
              }]
              prefetchurls = Data
      
              // postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls)
      
              // this.http
              // .get(environment.apiUrl + getClients, {
              //   headers: {
              //     Authorization: 'Bearer ' + accessToken,
              //     'Content-Type': 'application/json',
              //   },
              // })
              // .subscribe(
              //   (response: any) => {
              //     if (response['status'] == 200 || response['statusCode'] == 200) {
              // // this._SharedService.setCorpData(response.data)
      
              //     }
              //   })
      
              // this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((response) => { })
              // this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((response) => { })
              // this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((response) => { })
      
              // let loginAgain = false;
              // this.http.post('http://[::1]:3002/api/ap/create-session',{
              //   role:response.data.role,
              //   portal:'Admin',
              //   sessionId:response["token"],
              // }).subscribe((response:any)=>{
              //   console.log(response)
              //   if(response.status === 200 || response.status === '200'){
              //     setTimeout(() => {
              //       this.router.navigate(['/dashboard']);
              //       this.idleService.startMonitoring();
              //     }, 1000);
              //   }else if(response.status === 201 || response.status === '201'){
              //     loginAgain = true;
              //     Swal.fire({
              //       title:"Logout from active session",
              //       text:response.message,
              //       cancelButtonText:'No',
              //       showCancelButton:true,
              //       confirmButtonText:'Yes',
              //       allowEscapeKey:false,
              //       allowOutsideClick:false
              //     }).then((result:any)=>{
              //       if(result.isConfirmed){
              //         this.http.post('http://[::1]:3002/api/ap/delete-session',{
              //           sessionId:accessToken,
              //           action:'Session Timeout'
              //         }).subscribe((response:any)=>{
              //           console.log(response)
              //           if(response.status === 200 || response.status === "200"){
              //             this.onSubmit();
              //           }else{
              //             Swal.fire({title:'Error',text:response.message})
              //             // sessionStorage.clear()
              //           }
              //         })
              //       }else{
              //         this.router.navigate(['/login']);
              //       }
              //     })
              //   }else{
              //     Swal.fire({
              //       title:"Error",
              //       text:response.message
              //     })
              //     this.router.navigate(['/login'])
              //   }
              // })
      
              // if( loginAgain == false ){
                setTimeout(() => {
                  this.route.navigate(['/dashboard']);
                  // this.idleService.startMonitoring();
                }, 1000);
              // }
      
      
      
      
            }
            else if (response?.status == 206 || response?.statusCode == 206) {
              $("#activationlink").show()
      
              // Swal.fire({title:'Alert',text:"Please Contact System admin"})
              // $("#activationlink").show()
            }
            else if (response?.status == 400 || response?.statusCode == 400) {
              // alert("Invalid Details")
              // this.toastrService.error('Invalid Credentials', 'Error!');
              Swal.fire({ title: 'Error', text: response.message })
            }
            else {
              // alert("Invalid Details")
              // this.toastrService.error("Invalid Credentials", 'Error!');
              Swal.fire({ title: 'Error', text: response?.message??'Invalid Credentials' })
            }
          }, (error) => {
            Swal.fire({ title: 'Error', text: "Invalid Credentials" })
            // this.toastrService.error("Invalid Credentials", 'Error!');
          });
      
    } catch (error) {
      // this._LoaderService.HideLoader()


      Swal.fire({allowOutsideClick: false,
        title: 'Alert',
        text: 'Info',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Proceed',
      }).then((result) => {

        if (result.isConfirmed) {


          sessionStorage.clear()
          this.route.navigate(['/login']);

          // window.open(environment.commonLoginUrl)
        }
        else {
          sessionStorage.clear();
          this.route.navigate(['/login']);

          // window.open(environment.commonLoginUrl)

        }
      });

    }
  }

}
